import {css, html, LitElement, PropertyValues} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';
import {ifDefined} from 'lit/directives/if-defined.js';

@customElement('webs-listing-resources')
export class ListingResources extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    typographyStyles,
    moduleSpacingStyles,
    css`
      .m-listing-resources__intro.spaced { margin-bottom: 1rem; }
      .m-listing-resources__card { margin-bottom: 1rem; }
      .m-listing-resources--3-columns ::slotted(*:nth-of-type(n+2)) { margin-top: 1rem; }
      .m-listing-resources--4-columns ::slotted(*:nth-of-type(n+2)) { margin-top: 1rem; }

      @media only screen and (min-width: 576px){
        .m-listing-resources__intro { align-items: center; display: flex; flex-wrap: wrap; justify-content: space-between; }
        .m-listing-resources__intro ::slotted([slot="title"]) { margin-bottom: 0; }
      }

      @media only screen and (min-width: 768px){
        .m-listing-resources--3-columns ::slotted(*:nth-of-type(n+2)) { margin-top: 0; }
        .m-listing-resources--4-columns ::slotted(*:nth-of-type(n+2)) { margin-top: 0; }
        .m-listing-resources--3-columns ::slotted(*:nth-of-type(n+3)) { margin-top: 1.5rem; }
        .m-listing-resources--4-columns ::slotted(*:nth-of-type(n+3)) { margin-top: 1.5rem; }
      }

      @media only screen and (min-width: 992px){
        .m-listing-resources__intro.spaced { margin-bottom: 2rem; }
        .m-listing-resources--3-columns ::slotted(*:nth-of-type(n+2)) { margin-top: 0; }
        .m-listing-resources--4-columns ::slotted(*:nth-of-type(n+2)) { margin-top: 0; }
        .m-listing-resources--3-columns ::slotted(*:nth-of-type(n+4)) { margin-top: 4rem; }
        .m-listing-resources--4-columns ::slotted(*:nth-of-type(n+5)) { margin-top: 4rem; }
      }
    `
  ]

  private hasTitle: boolean;

  @property({attribute: 'space-top'})
  spaceTop = 'm'

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm'

  @property()
  id: string;

  @property({attribute: 'see-more-title'})
  linkTitle: string;

  @property({attribute: 'see-more-link'})
  href: string;

  @property({type: Number})
  columns = 3;

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
               class="m-listing-resources m-listing-resources--${this.columns}-columns ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div class="container">
          <div class="m-listing-resources__intro ${this.hasTitle || this.href && this.linkTitle ? 'spaced' : ''}">
            <slot name="title"></slot>
            ${this.href && this.linkTitle ? html`
            <webs-link-arrow href="${this.href}" text="${this.linkTitle}"></webs-link-arrow>
          ` : ''}
          </div>
          <webs-grid-row id="resources">
            <slot name="resource"></slot>
          </webs-grid-row>
        </div>
      </section>`
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);

    const intro: HTMLElement = this.shadowRoot.querySelector('.m-listing-resources__intro');
    const slotItems = intro.querySelector('slot').assignedElements();
    this.hasTitle = slotItems.length > 0;

    this.requestUpdate();

  }
}
